import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Client } from '@df/core/service/client';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { NModalLayout } from '../../../common/modal/layout/modal-layout.component';
import { NCmsUGC } from '../cms-ugc.component';

@DfModal({
    id: NCmsUGC.MODAL_ID,
    position: 'right',
    config: NModalLayout.Right.modalConfig(),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    templateUrl: './ugc-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UGCModalComponent {
    /**
     * Close ugc
     */
    constructor(
        private modalRef: ModalRef<UGCModalComponent>,
        @Inject(MODAL_DATA) readonly data: NCmsUGC.IModalData,
        private client: Client
    ) {}

    /**
     * Close ugc
     */
    close() {
        this.modalRef.close();
    }

    get pcSlides() {
        return [1.15, 2.7, 1.35, 1.35][this.client.sizeId];
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter() {
        return '16px';
    }
}
